<template>
  <div class="py-4 container-fluid">
    <div class=" row">
    
      <div class="col-12">
        <div class="card card-plain border border-info">
          <div class="card-header text-start bg-info">
            <div class="d-flex align-items-center">
            <p class="text-uppercase text-sm text-white">아이피 정보</p>  
            <button type="button"  class="btn btn-sm mb-0 ms-auto btn-primary"  data-bs-toggle="modal" data-bs-target="#add_ip">
                추가
            </button>
            </div>
        </div>
          <div class="card-body bg-white" style="border-bottom-left-radius: 1rem;border-bottom-right-radius: 1rem;">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">허용 아이피</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">메모</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">상태</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">처리일</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                  </tr>
                </thead>
                <tbody>

                  <tr v-for="(item,index) in list" :key="index">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{item.ip}}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{item.memo}}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <span class="badge badge-lg bg-gradient-primary" v-if="item.status =='Y'">허용</span>
                          <span class="badge badge-lg bg-gradient-warning" v-if="item.status =='N'">미허용</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{item.update_time}}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <!-- <div class="d-flex flex-column justify-content-center"> -->
                          <i class="fa fa-edit px-2" @click="CheckDetailEdit(item)"   data-bs-toggle="modal" data-bs-target="#edit_ip"></i>
                          <i class="fa fa-trash px-2" @click="CheckDetailDelete(item)"   data-bs-toggle="modal" data-bs-target="#delete_ip"></i>
                        <!-- </div> -->
                      </div>

                      
                    </td>
                  </tr>
                </tbody>
              </table>
              
            </div>
            <hr class="horizontal dark" />
            <ul class="pagination pagination-primary pagination-sm d-flex justify-content-center">
              <li class="page-item" v-if="max_page > 5">
                <a class="page-link" href="javascript:void(0);" @click="PrevPage()">
                  <i class="fa fa-angle-left"></i>
                </a>
              </li>
              <li class="page-item " :class="CheckPage(n)" v-for="n in max_page" :key="'Page_'+n">
                <a class="page-link" href="javascript:void(0);"  @click="ClickPaging(n)">
                  {{n}}
                </a>
              </li>
              <li class="page-item"  v-if="max_page > 5" >
                <a class="page-link" href="javascript:void(0);" @click="NextPage()">
                  <i class="fa fa-angle-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" id="add_ip">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">아이피 추가</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <div class="row mb-4">
              <div class="col-12">
                <label for="example-text-input" class="form-control-label">아이피</label>
                <input type="type" class="form-control" v-model="add_ip" placeholder="추가할 IP를 입력해주세요." />
                <label for="example-text-input" class="form-control-label">메모</label>
                <input type="type" class="form-control" v-model="add_memo" placeholder="추가시 메모를 입력해주세요." />
                <label for="example-text-input" class="form-control-label">상태</label>
                <select class="form-select" v-model="add_status">
                  <option value="" style="display:none">상태를 선택해주세요.</option>
                  <option :value="item.code"  v-for="(item,index) in status_list" :key="index">{{item.text}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="AddIP()">추가</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="edit_ip">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">아이피 수정</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <div class="row mb-4">
              <div class="col-12">
                <label for="example-text-input" class="form-control-label">아이피</label>
                <input type="type" class="form-control" v-model="edit_ip" placeholder="추가할 IP를 입력해주세요." />
                <label for="example-text-input" class="form-control-label">메모</label>
                <input type="type" class="form-control" v-model="edit_memo" placeholder="추가시 메모를 입력해주세요." />
                <label for="example-text-input" class="form-control-label">상태</label>
                <select class="form-select" v-model="edit_status">
                  <option value="" style="display:none">상태를 선택해주세요.</option>
                  <option :value="item.code"  v-for="(item,index) in status_list" :key="index">{{item.text}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="EditIP()">추가</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="delete_ip">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">아이피 삭제</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <div class="row mb-4">
              <div class="col-12">
                <label for="example-text-input" class="form-control-label">아이피</label>
                <input type="type" class="form-control" v-model="delete_ip" disabled/>
                <label for="example-text-input" class="form-control-label">메모</label>
                <input type="type" class="form-control" v-model="delete_memo" disabled />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="DeleteIP()">추가</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const exactMath = require('exact-math');
import {Modal} from 'bootstrap';
import { mapMutations } from "vuex";
const CryptoJS = require("crypto-js");


export default {
  name: "tables",
  components:{},
  data() {
    return {
      limit : 10,
      page : 1,
      max_page : 0,
      show : 3,
      add_ip : '',
      add_memo : '',
      add_status : '',
      auth :  this.$store.state.auth,
      list : [],
      status_list:[
        {code : 'Y' ,text : "사용"},
        {code : 'N' ,text : "미사용"}
      ],
      mobile :this.$store.state.mobile,
      show_mobile :this.$store.state.show_mobile,
      AddModel : '',
      EditModel : '',
      DeleteModel : '',
      edit_no : '',
      edit_ip : '',
      edit_memo : '',
      edit_status : '',
      delete_no : '',
      delete_memo : '',
      delete_ip : ''
    };
  },
  mounted(){
    this.AddModel = new Modal(document.getElementById('add_ip'));
    this.EditModel = new Modal(document.getElementById('edit_ip'));
    this.DeleteModel = new Modal(document.getElementById('delete_ip'));
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.isAbsolute = false;
    this.$store.state.showConfig = false;
    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      } 
    }
    this.GetIPList();
  },
  methods:{
    CheckDetailEdit(item){
      this.edit_no = item.no;
      this.edit_ip = item.ip;
      this.edit_memo = item.memo;
      this.edit_status = item.status;
    },
    CheckDetailDelete(item){
      this.delete_no = item.no;
      this.delete_ip = item.ip;
      this.delete_memo = item.memo;
    },
    ...mapMutations(["navbarMinimize"]),
    
    ClickPaging(i){
      this.page =i;
      this.GetAuthList();
    },
    CheckPage(i){
      
      const show = this.show;
      const page = this.page;
      var add_class ='';
      if((i+2) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i+1) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i-1) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i-2) == show){
        if(page ==i){
          add_class = " active ";
        }
      }else{
        add_class += 'd-none';
      }


      return add_class;

    },
    PrevPage(){
      const show = this.show;
      const show_prev = exactMath.sub(show,1);

      if(show_prev >= 3){
        this.show = show_prev;
      }else{
        this.show = show;
      }
    },
    NextPage(){
      const show = this.show;
      const show_next = exactMath.add(show,1);
      const max = exactMath.sub(this.max_page,2);

      if(show_next <= max){
        this.show = show_next;
      }else{
        this.show = max;
      }
    },
    GetIPList(){
      this.axios.post('/admin/site/GetIPList', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              this.list = body.list;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    
    EditIP(){
      const no = this.edit_no;
      const ip = this.edit_ip;
      const status = this.edit_status;
      const memo = this.edit_memo;
      const body = {ip,status,memo,no};
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/site/EditIP', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("아이피정보가 수정되었습니다.").then(
                ()=>{
                  this.$router.go();
                }
              )
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    
    
    DeleteIP(){
      const no = this.delete_no

      const body = {no};
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/site/DeleteIP', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("아이피정보를 삭제하였습니다.").then(
                ()=>{
                  this.$router.go();
                }
              )
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    AddIP(){
      const ip = this.add_ip;
      const memo = this.add_memo;
      const status = this.add_status;
      if(ip ==''){
        this.$alert.alert("등록할 IP를 입력해주세요.").then(
          ()=>{
            this.AddModel.show();
          }
        );
        return false;
      }

      if(status == ''){
        this.$alert.alert("상태를 선택해주세요.").then(
          ()=>{
            this.AddModel.show();
          }
        );
        return false;
      }

      
      const body = {ip,status,memo};
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/site/AddIP', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("IP를 추가하였습니다.");
              this.GetIPList();
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    CheckStatus(status){
      if(status =='Y'){
        return "사용"
      }else if(status =='N'){
        return "미사용"
      }
    }
  }
};
</script>
<style src="@vueform/toggle/themes/default.css"></style>